import {Column} from "prod-grid";
import {marker as _translate} from "@biesbjerg/ngx-translate-extract-marker"
import {ProdAppInjectorService} from "prod-shared";
import {TranslateService} from "@ngx-translate/core";

export class DipColumn extends Column {
  static override getTranslation(property: string, customTitle?: string): { title: string, tooltip: string } {
    const translate = ProdAppInjectorService.injector.get(TranslateService);
    let title;
    let tooltip;
    switch (customTitle ? customTitle : property) {
      case 'id': {
        title = _translate('column.id');
        break;
      }
      case 'username': {
        title = _translate('column.username');
        break;
      }
      case 'message': {
        title = _translate('column.message');
        break;
      }
      case 'details': {
        title = _translate('column.details');
        break;
      }
      case 'source': {
        title = _translate('column.source');
        break;
      }
      case 'createdAt': {
        title = _translate('column.created_at');
        break;
      }
      case 'equipment.organization.name': {
        title = _translate('column.organization');
        break;
      }
      case 'nationality.code': {
        title = _translate('column.nationality');
        break;
      }
      case 'vin': {
        title = _translate('column.vin');
        break;
      }
      case 'numberPlate': {
        title = _translate('column.number_plate');
        break;
      }
      case 'equipment.devices.name': {
        title = _translate('column.vhmd_id');
        break;
      }
      case 'equipment.latitude': {
        title = _translate('column.latitude');
        break;
      }
      case 'equipment.longitude': {
        title = _translate('column.longitude');
        break;
      }
      case 'brand': {
        title = _translate('column.brand');
        break;
      }
      case 'model': {
        title = _translate('column.model');
        break;
      }
      case 'color': {
        title = _translate('column.color');
        break;
      }
      case 'parkingSpotNumber': {
        title = _translate('column.parking_spot_number');
        break;
      }
      case 'parkedAt': {
        title = _translate('column.parked_at');
        break;
      }
      case 'equipment.linkedAt': {
        title = _translate('column.linked_at');
        break;
      }
      case 'equipment.lastBatteryEventAt': {
        title = _translate('column.last_battery_event_at');
        break;
      }
      case 'equipment.lastBatteryEventVoltage': {
        title = _translate('column.voltage');
        break;
      }
      case 'equipment.lastBatteryEventStatus': {
        title = _translate('column.last_battery_event_status');
        break;
      }
      case 'equipment.isDeleted': {
        title = _translate('column.is_deleted');
        break;
      }
      case 'userGroup.name': {
        title = _translate('column.user_group');
        break;
      }
      case 'userGroup.description': {
        title = _translate('column.description');
        break;
      }
      case 'permissions': {
        title = _translate('column.permissions');
        break;
      }
      case 'userGroup.users': {
        title = _translate('column.users');
        break;
      }
      case 'name': {
        title = _translate('column.name');
        break;
      }
      case 'address': {
        title = _translate('column.address');
        break;
      }
      case 'description': {
        title = _translate('column.description');
        break;
      }
      case 'latitude': {
        title = _translate('column.latitude');
        break;
      }
      case 'longitude': {
        title = _translate('column.longitude');
        break;
      }
      case 'hub.macAddress': {
        title = _translate('column.mac_address');
        break;
      }
      case 'hub.radius': {
        title = _translate('column.radius');
        break;
      }
      case 'hub.rssiPower': {
        title = _translate('column.rssi_power');
        break;
      }
      case 'hub.latitude': {
        title = _translate('column.latitude');
        break;
      }
      case 'hub.longitude': {
        title = _translate('column.longitude');
        break;
      }
      case 'lastSeen': {
        title = _translate('column.last_seen');
        break;
      }
      case 'device.deviceType.name': {
        title = _translate('column.device_type');
        break;
      }
      case 'type.name': {
        title = _translate('column.type');
        break;
      }
      case 'device.name': {
        title = _translate('column.device');
        break;
      }
      case 'batteryEvent.voltage': {
        title = _translate('column.voltage');
        break;
      }
      case 'batteryEvent.description': {
        title = _translate('column.battery_event.description');
        break;
      }
      case 'batteryEvent.warned': {
        title = _translate('column.warned');
        break;
      }
      case 'batteryEvent.alerted': {
        title = _translate('column.alerted');
        break;
      }
      case 'deviceType.name': {
        title = _translate('column.device_type');
        break;
      }
      case 'header': {
        title = _translate('column.header');
        break;
      }
      case 'version': {
        title = _translate('column.version');
        break;
      }
      case 'organizations': {
        title = _translate('column.organizations');
        break;
      }
      case 'filePath': {
        title = _translate('column.file_path');
        break;
      }
      case 'nationality.country': {
        title = _translate('column.country');
        break;
      }
      case 'firstName': {
        title = _translate('column.first_name');
        break;
      }
      case 'lastName': {
        title = _translate('column.last_name');
        break;
      }
      case 'groups': {
        title = _translate('column.groups');
        break;
      }
      case 'notifierOrganizations': {
        title = _translate('column.notifier_organizations');
        break;
      }
      case 'lastLogin': {
        title = _translate('column.last_login');
        break;
      }
      case 'isEnabled': {
        title = _translate('column.is_enabled');
        break;
      }
      case 'isDeleted': {
        title = _translate('column.is_deleted');
        break;
      }
      case 'organizationUserGroup.organization.name': {
        title = _translate('column.organization_user_group.organization');
        break;
      }
      case 'organization.name': {
        title = _translate('column.notifier_organization.organization');
        break;
      }
      case 'tag': {
        title = _translate('column.tag');
        break;
      }
      case 'batteryEvent.vin': {
        title = _translate('column.battery_event.vin');
        break;
      }
      case 'batteryEvent.numberPlate': {
        title = _translate('column.battery_event.number_plate');
        break;
      }
      case 'vhmdId': {
        title = _translate('column.vhmd_id');
        break;
      }
      case 'vhmdCounter': {
        title = _translate('column.vhmd_counter');
        break;
      }
      case 'rssi': {
        title = _translate('column.rssi');
        break;
      }
      case 'vhmhId': {
        title = _translate('column.vhmh_id');
        break;
      }
      case 'vhmhCounter': {
        title = _translate('column.vhmh_counter');
        break;
      }
      case 'voltage': {
        title = _translate('column.voltage');
        break;
      }
      case 'ignition': {
        title = _translate('column.ignition');
        break;
      }
      case 'charger': {
        title = _translate('column.charger');
        break;
      }
      case 'macAddress': {
        title = _translate('column.mac_address');
        break;
      }
      default: {
        title = property;
      }
    }

    title = translate.instant(title);
    tooltip = tooltip ? translate.instant(tooltip) : '';
    return {title, tooltip};
  }
}
